/**
 * Where the login page may send someone after they sign in (`/login?next=…`).
 * Only a path on this site: anything that could reach another host is refused, so
 * the login page can't be used to send a freshly signed-in person somewhere else.
 * A fragment is dropped (a secret may ride in one, as on /alert-action).
 */
export function safeNext(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string' || raw.length === 0 || raw.length > 512) return null;
  // A single leading slash only: "//host" and "/\host" are other hosts to a browser.
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return null;
  let decoded: string;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return null;
  }
  if (decoded.startsWith('//') || decoded.startsWith('/\\') || decoded.includes('\\')) return null;
  let url: URL;
  try {
    url = new URL(raw, 'https://app.invalid');
  } catch {
    return null;
  }
  if (url.origin !== 'https://app.invalid') return null;
  // Dot segments can normalise "/..//host" to "//host" (PR #1064 review).
  if (url.pathname.startsWith('//') || url.pathname.includes('\\')) return null;
  if (url.pathname === '/login' || url.pathname.startsWith('/login/')) return null;
  return `${url.pathname}${url.search}`;
}
